// 다국어(i18n) 핵심 모듈
// 새 언어를 추가하려면:
//   1) src/i18n/locales/<코드>/ 폴더를 만들고 ko 폴더 구조를 복사해 번역
//   2) 아래 messages 객체와 SUPPORTED_LANGUAGES 배열에 등록
import ko from './locales/ko/index';
import en from './locales/en/index';
import vi from './locales/vi/index';

export const SUPPORTED_LANGUAGES = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: 'English' },
  { code: 'vi', label: 'Tiếng Việt' },
];

export const DEFAULT_LANGUAGE = 'ko';

const messages = { ko, en, vi };

const STORAGE_KEY = 'app.language';

export function getStoredLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && messages[stored]) return stored;
  } catch (e) {
    // localStorage 접근 불가 환경 (SSR, 비공개 모드 일부)
  }
  return DEFAULT_LANGUAGE;
}

export function setStoredLanguage(lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {
    // ignore
  }
}

// dot-path 로 중첩된 객체에서 값 조회: "header.systemTitle" -> messages[lang].header.systemTitle
function resolvePath(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
}

// {placeholder} 치환
function format(str, params) {
  if (!params || typeof str !== 'string') return str;
  return str.replace(/\{(\w+)\}/g, (match, key) =>
    Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match
  );
}

// 번역 함수 생성: lang 에 해당하는 t(key, params) 반환
export function createTranslator(lang) {
  const dict = messages[lang] || messages[DEFAULT_LANGUAGE];
  const fallback = messages[DEFAULT_LANGUAGE];
  return function t(key, params) {
    let value = resolvePath(dict, key);
    if (value === undefined) {
      value = resolvePath(fallback, key);
    }
    if (value === undefined) {
      // 누락된 키는 키 자체를 반환하여 누락을 인지하기 쉽게 함
      return key;
    }
    return format(value, params);
  };
}

export function isSupported(lang) {
  return Boolean(messages[lang]);
}
